module.exports = __webpack_public_path__ + "images/payrollpanda-logo-lg.png";


//////////////////
// WEBPACK FOOTER
// ./images/payrollpanda-logo-lg.png
// module id = 1122
// module chunks = 1